import { Routes, Route } from 'react-router-dom'
import { Toaster } from '@/components/ui/sonner'
import SiteHeader from '@/components/SiteHeader'
import SiteFooter from '@/components/SiteFooter'
import Home from '@/pages/Home'
import Shop from '@/pages/Shop'
import ProductDetail from '@/pages/ProductDetail'
import Cart from '@/pages/Cart'
import Checkout from '@/pages/Checkout'
import About from '@/pages/About'
import Contact from '@/pages/Contact'
import Settings from '@/pages/Settings'
import NotFound from '@/pages/NotFound'

export default function App() {
  return (
    <div data-upbo-src="src/App.tsx:17" className="flex min-h-dvh flex-col bg-white text-[#5f3f38]">
      <SiteHeader />
      <main data-upbo-src="src/App.tsx:19" className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/cua-hang" element={<Shop />} />
          <Route path="/san-pham/:id" element={<ProductDetail />} />
          <Route path="/gio-hang" element={<Cart />} />
          <Route path="/thanh-toan" element={<Checkout />} />
          <Route path="/gioi-thieu" element={<About />} />
          <Route path="/lien-he" element={<Contact />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <SiteFooter />
      <Toaster />
    </div>
  )
}
